module.exports = __webpack_public_path__ + "static/media/Medical1.ffed92c2.jpg";